import * as types from './index';

export const getSubmissionsAction = () => {
    return {
        type: types.GET_SUBMISSIONS,
    }
};